import {
  MRT_GlobalFilterTextField as RoomlayoutListGlobalFilterTextField,
  MRT_ShowHideColumnsButton as RoomlayoutListShowHideColumnsButton,
  MRT_TableInstance,
  MRT_ToggleFiltersButton as RoomlayoutListToggleFiltersButton
} from "material-react-table";
import { useTranslation } from "react-i18next";
import { Button, Grid2, IconButton, Tooltip, Typography } from "@mui/material";
import { AddBox, Delete } from "@mui/icons-material";
import { RoomlayoutServiceRow } from "../Domain/Types/FacilityService-Roomlayout-row.types";

type Props = {
  table: MRT_TableInstance<RoomlayoutServiceRow>;
  disabledDeleteButton: boolean;
  onDelete: () => void;
};
export const RoomlayoutListTopToolbar = ({ table, disabledDeleteButton, onDelete }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid2
      container
      sx={{ display: "flex", p: 2, justifyContent: "space-between", alignItems: "center" }}
    >
      <Typography variant={"h5"} sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
        {t("Room Layout")}
      </Typography>

      <Grid2 sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }} gap={1}>
        {/* import MRT sub-components */}
        {/* to avoid duplication, changed the name */}
        <RoomlayoutListGlobalFilterTextField table={table} />
        <RoomlayoutListToggleFiltersButton table={table} />
        <RoomlayoutListShowHideColumnsButton table={table} />

        {/* delete selected roomlayout button */}
        <Tooltip title={t("Delete selection")}>
          <span>
            <IconButton
              color="error"
              data-testid="handle-remove-roomlayout-btn"
              disabled={disabledDeleteButton}
              onClick={onDelete}
              size="large"
            >
              <Delete />
            </IconButton>
          </span>
        </Tooltip>

        {/* add new roomlayout button */}
        <Button
          data-testid="Add-new-roomlayout-btn"
          onClick={() => table.setCreatingRow(true)}
          sx={{ height: "fit-content", alignSelf: "center", p: "6px 12px" }}
        >
          <AddBox sx={{ mr: 1 }} />
          {t("_addRoomlayout")}
        </Button>
      </Grid2>
    </Grid2>
  );
};
